<template>
    <div>
        <v-alert border-color="primary" border="start" dense v-if="nb_inscrits_to_validate_webservice == 0">Il
            n'y a aucun coureur en attente de validation par PPS</v-alert>
        <div v-else>
            <v-alert border-color="primary" border="start" dense>
                Il y a <b>{{ nb_inscrits_to_validate_webservice }} coureur(s)</b> en attente de validation par PPS.
            </v-alert>

            <div class="d-flex justify-center">
                <v-btn v-if="mainStore.authAdmin.isSportipsAdmin" class="my-2" color="primary-dark" variant="elevated"
                    elevation="0" @click="verify_webservice" :loading="loading">Lancer la
                    validation</v-btn>
            </div>


            <v-table>
                <thead>
                    <tr>
                        <th class="text-left">Nom - Prénom</th>
                        <th class="text-left">Date de naissance</th>
                        <th class="text-left">Numéro de PPS</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="inscription in pending_webservice.list_inscriptions" :key="inscription.id">
                        <td>{{ inscription.nom }} {{ inscription.prenom }}</td>
                        <td>{{ $moment(inscription.date_naissance).format("DD/MM/YYYY") }}</td>
                        <td>
                            {{ inscription.champs.numero_pps }}
                        </td>

                    </tr>
                </tbody>
            </v-table>


        </div>
        <v-snackbar v-model="snackbar_success" timeout="6000">
            <div>Les coureurs ont bien été validés par le webservice. Les coureurs restants ont un numéro de PPS non
                valide</div>

            <template v-slot:actions>
                <v-btn color="green-darken-1" variant="elevated" @click="snackbar_success = false"> Fermer </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";

import AdminService from "@/services/admin.service.js";
export default {
    name: 'ValidationLicences',
    data() {
        return {
            pending_webservice: {},
            loading: false,
            snackbar_success: false,
            // Your component data goes here
        };
    },
    methods: {
        async verify_webservice() {
            this.loading = true;
            let request = await AdminService.validatePPS(this.mainStore.module.id);
            this.loading = false;
            if (!request.error) {
                this.fetch_list_pendings();
                this.snackbar_success = true;
            }
        },
        async fetch_list_pendings() {
            let request = await AdminService.getValidationPPSPendings(this.mainStore.module.id);
            if (!request.error) {
                this.pending_webservice = request;
            }
        }
        // Your component methods go here
    },
    computed: {
        ...mapStores(useMainStore),
        nb_inscrits_to_validate_webservice() {
            if (!this.pending_webservice || !this.pending_webservice.list_inscriptions) return 0;
            return this.pending_webservice.list_inscriptions.length;
        },
        // Your computed properties go here
    },
    async mounted() {
        await this.fetch_list_pendings();
        // Your mounted lifecycle hook goes here
    }
};
</script>

<style scoped>
/* Your component styles go here */
</style>